import { render, staticRenderFns } from "./myCopysend.vue?vue&type=template&id=11baf85d&scoped=true&lang=pug"
import script from "./myCopysend.vue?vue&type=script&lang=js"
export * from "./myCopysend.vue?vue&type=script&lang=js"
import style0 from "./myCopysend.vue?vue&type=style&index=0&id=11baf85d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11baf85d",
  null
  
)

export default component.exports